import { all, put, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { createTinyAuthenticatedUrlRequest } from '../../api/Notification/owners/createTinyAuthenticatedUrlCommand';

import * as ActionTypes from './actionTypes';

function* getBackOfficeLinkWorker({ payload: json }) {
  const { redirectUrl, orderId } = json;
  const meta = { orderId, redirectUrl, indexer: orderId };

  if (window.location.hostname === 'localhost') {
    yield executeSagaRequest(
      ActionTypes.LOAD_BACK_OFFICE_LINK,
      createTinyAuthenticatedUrlRequest({ ...json, forceLocalhost: true }),
      meta,
    );
  } else {
    yield executeSagaRequest(
      ActionTypes.LOAD_BACK_OFFICE_LINK,
      createTinyAuthenticatedUrlRequest(json),
      meta,
    );
  }

  yield put(ActionTypes.LOAD_BACK_OFFICE_LINK.end({ indexer: orderId }));
}

function* loadBackOfficeLinkWatcher() {
  yield takeEvery(
    ActionTypes.LOAD_BACK_OFFICE_LINK.BASE,
    getBackOfficeLinkWorker,
  );
}

export default function* mainSaga() {
  try {
    yield all([loadBackOfficeLinkWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}
